import { render, staticRenderFns } from "./CountedServiceTypeTable.vue?vue&type=template&id=89d3df4a&"
import script from "./CountedServiceTypeTable.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports